import axios from "axios";

const axiosInstance = axios.create({
    headers: {
        common: {
            Accept: "application/json",
            "Content-Type": "application/json",
        },
    },
});

axiosInstance.interceptors.response.use(undefined, function (error) {
    if (error.response?.status === 401) {
        return Promise.reject(error);
    } else {
        if (!error.config?.preventDefaultError) {
            console.error("Chyba při komunikaci se serverem.");
        }
        return Promise.reject(error);
    }
});

export default axiosInstance;